import { TableRowSkeleton } from "./skeleton";

interface ListTableSkeletonProps {
  rows?: number;
  cols?: number;
}

export function ListTableSkeleton({ rows = 8, cols = 6 }: ListTableSkeletonProps) {
  return (
    <div className="rounded-xl border bg-card-white p-4">
      {Array.from({ length: rows }).map((_, index) => (
        <TableRowSkeleton key={index} cols={cols} />
      ))}
    </div>
  );
}
